// Reference-counted body scroll lock (stacked overlays don't unlock early); restores
// the app's original inline overflow/padding.

let lockCount = 0;
let previousOverflow = '';
let previousPaddingRight = '';

/** Locks body scroll; call the returned function to release (idempotent). */
export const lockBodyScroll = (): (() => void) => {
    if (lockCount === 0) {
        // Pad by the scrollbar width so removing it (Windows/Linux, always-on
        // scrollbars) doesn't shift the page right. Zero-width on overlay scrollbars.
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        previousOverflow = document.body.style.overflow;
        previousPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        if (scrollbarWidth > 0) {
            const current = Number.parseFloat(getComputedStyle(document.body).paddingRight) || 0;
            document.body.style.paddingRight = `${current + scrollbarWidth}px`;
        }
    }
    lockCount += 1;
    let released = false;
    return () => {
        if (released) {
            return;
        }
        released = true;
        lockCount -= 1;
        if (lockCount === 0) {
            document.body.style.overflow = previousOverflow;
            document.body.style.paddingRight = previousPaddingRight;
        }
    };
};
